// extracted by mini-css-extract-plugin
export default {"judge":"JudgeItem_judge__96nES","item":"JudgeItem_item__ozj15"};